import { notification } from 'antd';

import apiShipper from '../services/apiShipper';

export const getPagadores = async user => {
  let pagadores = [];

  try {
    const idPagadores = user.clientes_pagadores;

    if (idPagadores) {
      const { data } = await apiShipper.get('/clientes/pagadores', {
        params: {
          idcliente: idPagadores,
        },
      });

      const clientesFilter = data.reduce((clienteLista, clienteCurrent) => {
        const hasCliente = clienteLista.some(
          c => c.cnpj === clienteCurrent.cnpj
        );
        if (!hasCliente) clienteLista.push(clienteCurrent);
        return clienteLista;
      }, []);

      pagadores = clientesFilter;
    }
  } catch {
    notification.error({
      message: 'Ops, não foi possível recuperar os clientes',
      description:
        'Por favor, entre em contato com nosso suporte caso o problema persistir.',
    });
  }

  return pagadores;
};
